import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ThemeModule} from '../@theme/theme.module';
import {SelectTimezoneComponent} from './components/select-timezone/select-timezone.component';
import {TimezoneFilterPipe} from './pipes/timezone-filter-pipe.pipe';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {SelectSiteComponent} from './components/select-site/select-site.component';
import {SelectSitePipe} from './pipes/select-site.pipe';
import {DatepickerComponent} from './components/datepicker/datepicker.component';
import { SelectUserComponent } from './components/select-user/select-user.component';
import { SelectMethodComponent } from './components/select-method/select-method.component';
import { SensorStatusByMinuteChart } from './components/sensor-status-by-minute-chart/sensor-status-by-minute-chart.component';
import {UserFilterPipe} from './pipes/user-filter.pipe';
import {ObjectsFilterPipe} from './pipes/objects.filter.pipe';
import { SelectPlatformComponent } from './components/select-platform/select-platform.component';
import { SelectServerComponent } from './components/select-server/select-server.component';
import {SensorFilterPipe} from './pipes/sensor-filter.pipe';
import {ProfileFilterPipe} from './pipes/profile-filter.pipe';
import {ModuleFilterPipe} from './pipes/module-filter.pipe';
import {SensorDropInitComponent} from '../pages/sensors/sensor-drop-init/sensor-drop-init.component';
import {SensorsSitesComponent} from '../pages/sensors/sensors-sites/sensors-sites.component';
import {ServerFilterPipe} from "./pipes/server-filter.pipe";
import {SelectSensorComponent} from "./components/select-sensor/select-sensor.component";
import {GoogleChartDirective} from "./components/charts/google-chart.directive";

@NgModule({
  imports: [ReactiveFormsModule, FormsModule, ThemeModule],
  exports: [ReactiveFormsModule,
            FormsModule,
            ThemeModule,
            SensorFilterPipe,
            ProfileFilterPipe,
            SelectSitePipe,
            SensorsSitesComponent,
            SensorStatusByMinuteChart,
    ServerFilterPipe,
    ModuleFilterPipe],
  declarations: [
    SelectTimezoneComponent,
    TimezoneFilterPipe,
    NotFoundComponent,
    SelectSitePipe,
    UserFilterPipe,
    SelectSiteComponent,
    DatepickerComponent,
    SelectUserComponent,
    SelectMethodComponent,
    SensorStatusByMinuteChart,
    ObjectsFilterPipe,
    SelectPlatformComponent,
    SelectServerComponent,
    SensorFilterPipe,
    ProfileFilterPipe,
    SensorDropInitComponent,
    SensorsSitesComponent,
    ModuleFilterPipe,
    ServerFilterPipe,
    SelectSensorComponent,
    GoogleChartDirective
  ],
  entryComponents: [
    SelectTimezoneComponent,
    SelectSiteComponent,
    SelectUserComponent,
    SelectMethodComponent,
    SensorStatusByMinuteChart,
    SelectPlatformComponent,
    DatepickerComponent,
    SelectServerComponent,
    SensorDropInitComponent,
    SensorsSitesComponent,
    SelectSensorComponent,
  ],
})

export class SharedModule {

}
